import Api from "./api";



export default new class FileService extends Api {
    prefix = "file";

    upload_file(data, progress_callback) {
        return this.api('post', '', { data, onUploadProgress: progress_callback });
    };

    update_file(data, progress_callback, id) {
        return this.api('put', "/" + id, { data, onUploadProgress: progress_callback });
    };

    download_file(progress_callback, id) {
        return this.api('get', "/download/" + id, {
            onDownloadProgress: progress_callback, maxBodyLength: Infinity, responseType: 'blob',
            maxContentLength: Infinity, headers: { Accept: "application/octet-stream" }
        })
    }
};
